import Select from "../../../Form/Select";
import Radio from "../../../Form/Radio";
import Checkbox from "../../../Form/Checkbox";
import { useContext, useEffect, useRef, useState } from 'react';
import ToastContext from '../../../../contexts/toast';
import StatusContext from '../../../../contexts/status';
import { FormUtility } from '../../../Utility/FormUtility';
import { PlessoService } from "../../../../services/PlessoService";
import { RichiestaIscrizioneScolastica } from "../../../../models/RichiestaIscrizioneScolastica";
import { RichiestaService } from "../../../../services/RichiestaService";
import AlertMessage from "../../../Utility/Alert/AlertMessage";
import tuttiComuni from "../../../Utility/json/tuttiComuni";

const Step4IscrizioneScolastica = (props) => {
    const previousBtnFunction = props.previousBtnFunction;
    const nextBtnFunction = props.nextBtnFunction;
    const afterSubmitFunction = props.afterSubmitFunction;
    const richiesta = props.richiesta;
    const annoScolastico = richiesta.annoEducativo?.split("/")[0]+"-20"+richiesta.annoEducativo?.split("/")[1];

    const [validate, setValidate] = useState(false);
    const [inputErrors, setInputErrors] = useState([]);
    const utility = new FormUtility();
    const toastContext = useContext(ToastContext);
    const statusContext = useContext(StatusContext);
	const formRef = useRef(null);
    const isDirty = useRef(false);

    const [datiIscrizioneScolastica, setDatiIscrizioneScolastica] = useState(new RichiestaIscrizioneScolastica());

    const [annoCorsoOptions, setAnnoCorsoOptions] = useState([]);
    const [isComunicazioneVisible, setIsComunicazioneVisible] = useState(false);
    const [comuni, setComuni] = useState(null);
    const [plessi, setPlessi] = useState([]);
    const [loadingData, setLoadingData] = useState();
    const [indirizziDiStudioOption, setIndirizziDiStudioOption] = useState([]);
    const isFormInitialized = useRef(false);
    const comuneSelected = useRef();
    const [showWarning, setShowWarnig] = useState(false);
    const [inSave, setInSave] = useState(false);

    const ordinegradoOption = [
        { key: 1, label: "Scuola secondaria di primo grado (scuola media)" },
        { key: 2, label: "Scuola secondaria di secondo grado (scuola superiore)"}
    ];

    const mapOrdineGrado = {
        "MEDIA": 1,
        "SUPERIORE": 2
    }

    const plessoService = new PlessoService();
    const richiestaService = new RichiestaService();

    useEffect(() => {
      if (isDirty.current) {
        props.onChangedValue();
      }
    }, [isDirty]);

    useEffect(() => {
        if(!props.richiesta?.richiestaIscrizioneScolastica) {
            setDatiIscrizioneScolastica(new RichiestaIscrizioneScolastica());
            setIsComunicazioneVisible(false);
            setShowWarnig(false);
        } else {
            setShowWarnig(datiIscrizioneScolastica.ordineGrado === 'SUPERIORE' && props.richiesta?.richiestaDatiBeneficiario?.eta < 13);
        }
    }, [props.richiesta]);

    const onNextBtnClick = (e)=>{
        if (e){
            e.preventDefault();
            e.stopPropagation();
        }
        if (nextBtnFunction)nextBtnFunction();
    }
    const onPrevBtnClick = (e)=>{
        if (e){
            e.preventDefault();
            e.stopPropagation();
        }
        if (nextBtnFunction)previousBtnFunction();
    }

    const onChangeOrdineGrado = (event) => {
        if(!event) {
            datiIscrizioneScolastica.ordineGrado = null;
            resetFormData();
            return;
        }

        datiIscrizioneScolastica.ordineGrado = event === 1 ? 'MEDIA' : 'SUPERIORE';
        setDatiIscrizioneScolastica({...datiIscrizioneScolastica, plesso: null, indirizzoDiStudioId: null});
        setIndirizziDiStudioOption([]);
        setPlessi([]);

        if(event === 2 && richiesta?.richiestaDatiBeneficiario?.eta < 13) {
            setShowWarnig(true);
        } else {
            setShowWarnig(false);
        }

        let options = [];

        options = event === 1 ? [
            { key: 1, label: "1° anno" },
            { key: 2, label: "2° anno" },
            { key: 3, label: "3° anno" }
        ] : [
            { key: 1, label: "1° anno" },
            { key: 2, label: "2° anno" },
            { key: 3, label: "3° anno" },
            { key: 4, label: "4° anno" },
            { key: 5, label: "5° anno" },
            { key: 6, label: "6° anno" }
        ];

        setAnnoCorsoOptions(options);

        if(datiIscrizioneScolastica?.comune) {
            getPlessiByBandoIdAndComuneId(datiIscrizioneScolastica.comune.id);
        }

        if (validate) {
            setTimeout(() => {
                setFormErrors(false);
            }, 0);
        }
    }

    const setFormErrors = (setFocus = true) => {
        const errors = utility.getAllInputErrors(formRef);
        setInputErrors(errors.map(el => el.id));
        if (setFocus && errors.length > 0) {
          errors[0].focus();
        }
    }

    const sendData = async () => {
        setValidate(true);

        const validity = formRef.current.checkValidity();
        if (!validity) {
            setFormErrors();
            return;
        }

        setInputErrors([]);
        
        if(!isDirty.current){
            onNextBtnClick(null);
            return;
        }

        setInSave(true);
        const result = await richiestaService.saveStep4(richiesta.id, datiIscrizioneScolastica).catch((err) => {
            toastContext.error(utility.getErrorMsg(err), 2000);
            console.log(err);
        });
        setInSave(false);
        isDirty.current = false;
        console.log("step4 ", result);
        onNextBtnClick(null);
        if (afterSubmitFunction)afterSubmitFunction(result);
        toastContext.success("Dati salvati", 6000);
    }

    const onChangeIsAssegnazioneConfermata = (isConfirmed) => {
        setDatiIscrizioneScolastica({
            ...datiIscrizioneScolastica,
            isAssegnato: isConfirmed,
            confermaComunicazioneAssegnazione: isConfirmed
                ? null
                : datiIscrizioneScolastica.confermaComunicazioneAssegnazione,
            plesso: !isConfirmed? null : datiIscrizioneScolastica.plesso,
            comune: !isConfirmed? null : datiIscrizioneScolastica.comune,
            indirizzoDiStudio: !isConfirmed? null : datiIscrizioneScolastica.indirizzoDiStudio,
        });
        setPlessi([]);
        setIndirizziDiStudioOption([])
        setIsComunicazioneVisible(!isConfirmed);

        if (validate) {
            setTimeout(() => {
                setFormErrors(false);
            }, 0);
        }

        if (!isConfirmed) {
            formRef.current?.reportValidity();
        }
    }

    useEffect(() => {
        const getComuni = async () => {
            const comuni = [ ...tuttiComuni ]
                                .filter(el => el.denominazione_regione === 'Toscana' && el.data_fine_validita === null)
                                .sort((a, b) => a.denominazione.localeCompare(b.denominazione));
            setComuni(comuni);
        };

        getComuni();

        if(richiesta?.richiestaIscrizioneScolastica) {
            const iscrizioneScolastica = richiesta.richiestaIscrizioneScolastica;
            onChangeAnnoCorso(iscrizioneScolastica.annoCorso, false);
            onChangeConfermaAssegnazione(iscrizioneScolastica.confermaComunicazioneAssegnazione);
            onChangeOrdineGrado(mapOrdineGrado[iscrizioneScolastica.ordineGrado]);
            onChangeIsAssegnazioneConfermata(iscrizioneScolastica.isAssegnato);
            setDatiIscrizioneScolastica({...iscrizioneScolastica});
        }

        return () => {
            statusContext.removeEvent('onbeforeunload');
        }
    }, []);

    useEffect(() => {
        if(!isFormInitialized.current && comuni && comuni?.length > 0 && richiesta?.richiestaIscrizioneScolastica?.comune) {
            const comune = richiesta.richiestaIscrizioneScolastica.comune;
            setDatiIscrizioneScolastica({
                ...datiIscrizioneScolastica,
                comune: comune
            });
            getPlessiByBandoIdAndComuneId(comune.id);
        }
    }, [comuni]);

    useEffect(() => {
        if (!isFormInitialized.current && plessi?.length > 0 && richiesta?.richiestaIscrizioneScolastica?.plesso) {
            const plesso = plessi.find(el => el.id === richiesta?.richiestaIscrizioneScolastica?.plesso.id);

            setDatiIscrizioneScolastica(prevState => ({
                ...prevState,
                plesso: plesso,
                indirizzoDiStudio: richiesta.richiestaIscrizioneScolastica.indirizzoDiStudio
            }));

            setIndirizziDiStudioOption(plesso?.indirizzi);
            isFormInitialized.current = true;
        }
    }, [plessi, richiesta]);

    const onChangeComune = (value) => {
        if(!value) {
            setDatiIscrizioneScolastica({
                ...datiIscrizioneScolastica,
                plesso: null,
                indirizzoDiStudio: null,
                comune: null
            });
            setPlessi([]);
            setIndirizziDiStudioOption([]);
            setLoadingData(false);
            return;
        }

        comuneSelected.current = comuni.find(el => el.id === value) ?? null;
        
        setDatiIscrizioneScolastica({
            ...datiIscrizioneScolastica,
            plesso: null,
            indirizzoDiStudio: null,
            comune: comuneSelected.current
        });

        getPlessiByBandoIdAndComuneId(value);

        if (validate) {
            setTimeout(() => {
                setFormErrors(false);
            }, 0);
        }
    }

    const getPlessiByBandoIdAndComuneId = (id) => {
        setLoadingData(true);
        plessoService.getAllByBandoIdAndComuneId(props.richiesta.bando.id, id).then((resp) => {
            const isSuperiore = datiIscrizioneScolastica.ordineGrado === 'SUPERIORE';
            resp = resp?.filter(
                (plesso) =>
                    isSuperiore
                        ? plesso.indirizzi.length > 0
                        : plesso.indirizzi.length === 0
                )
                .map((el) => ({ ...el, label: `${el.denominazione} [${el.codice}]` }))
                .sort((a, b) => (a?.denominazione > b?.denominazione ? 1 : -1));
                
            setPlessi(resp);
            setLoadingData(false);
            
            if(resp.length === 0) {
                let nomeComune = comuneSelected.current?.denominazione;
                setIndirizziDiStudioOption([]);
                toastContext.warning(`Non sono presenti scuole di ${datiIscrizioneScolastica.ordineGrado === 'SUPERIORE'? "Secondo" : "Primo"}  grado nel comune di ${nomeComune}`);
            }
        });
    }

    const onChangePlesso = (plessoValue) => {
        if (!plessoValue) {
            setDatiIscrizioneScolastica({ ...datiIscrizioneScolastica, plesso: null });
            setIndirizziDiStudioOption([]);
            return;
        }
        const plesso = plessi.find(el => el.id === plessoValue);
        
        setIndirizziDiStudioOption(plesso.indirizzi);
        setDatiIscrizioneScolastica({...datiIscrizioneScolastica, plesso: plesso, indirizzoDiStudio: null});

        if (validate) {
            setTimeout(() => {
                setFormErrors(false);
            }, 0);
        }
    }

    const onChangeIndirizzoStudi = (value) => {
        if(!value) {
            setDatiIscrizioneScolastica({...datiIscrizioneScolastica, indirizzoDiStudio: null});
            return;
        }

        const indirizzo = indirizziDiStudioOption?.find(el => el.id === value);
        
        setDatiIscrizioneScolastica({...datiIscrizioneScolastica, indirizzoDiStudio: indirizzo});

        if (validate) {
            setTimeout(() => {
                setFormErrors(false);
            }, 0);
        }
    }

    const onChangeAnnoCorso = (value, onEdit = true) => {

        if(!value) {
            resetFormData();
            return;
        }
        
        setDatiIscrizioneScolastica({
            ...datiIscrizioneScolastica,
            annoCorso: value
        });

        if (onEdit) {
            statusContext.addEvent('onbeforeunload');
        }

        if (validate) {
            setTimeout(() => {
                setFormErrors(false);
            }, 0);
        }
    }

    const onChangeConfermaAssegnazione = (value) => {

        if(value === null) return;

        setDatiIscrizioneScolastica({
            ...datiIscrizioneScolastica,
            confermaComunicazioneAssegnazione: value
        })

        if (validate) {
            setTimeout(() => {
                setFormErrors(false);
            }, 0);
        }
    }

    const resetFormData = () => {
        const newDatiIscrizioneScolastica = {
            ...datiIscrizioneScolastica,
            annoCorso: null,
            comune: null,
            plesso: null,
            indirizzoDiStudio: null,
        };

        setPlessi([]);
        setIndirizziDiStudioOption(null);
        setDatiIscrizioneScolastica(newDatiIscrizioneScolastica);
    }

    return(
        <div className=" rtds-my-12">
            <div className="rtds-mb-6">
                <h1 className="rtds-text-2xl rtds-font-bold">Dati sull'iscrizione scolastica</h1>
            </div>

            <div className="rtds-background-01 rtds-p-6 rtds-border rtds-border-gray-02">
                <div className="rtds-pb-6 rtds-space-y-4 rtds-border-b rtds-border-gray-02">
                    <p>
                        I campi obbligatori sono contrassegnati da un asterisco&nbsp;
                        <abbr
                            className="rtds-font-bold rtds-no-underline"
                            title="obbligatorio"
                        >
                            *
                        </abbr>
                    </p>
                </div>

                <form
                    noValidate
                    ref={formRef}
                    id="hasValidationForm"
                    className="has-js-validation-form rtds-py-6 rtds-space-y-4"
                >
                    <h2 className="rtds-text-xl rtds-font-bold">Informazioni sulla scuola che frequenterà lo studente beneficiario nell’anno scolastico {annoScolastico}</h2>
                    <AlertMessage
                        title={"Attenzione!"}
                        message={`Compila attentamente questa sezione: se indichi una scuola o classe di frequenza errata per l'a.s. ${annoScolastico}, potresti ricevere un contributo inferiore e non avrai diritto a richiedere la differenza in un secondo momento. `}
                        classDiv={''}
                        classArticle={''}
                        iconName={'mini--information-circle'}
                    />
                   
                        <div className="rtds-field-row">
                            <Select
                                classDiv={"rtds-mt-0 lg:rtds-mt-0"}
                                label={"Ordine e grado"}
                                id={"oridnegrado"}
                                classSelect={""}
                                onChange={(event) => {isDirty.current = true; onChangeOrdineGrado(parseInt(event.target.value));}}
                                baseOption={"Nessuna selezione"}
                                bindKey={"key"}
                                bindValue={"label"}
                                options={ordinegradoOption}
                                inputErrors={inputErrors}
                                required={true}
                                value={mapOrdineGrado[datiIscrizioneScolastica?.ordineGrado] ?? ""}
                            />
                            <Select
                                classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                label={"Anno di corso (classe)"}
                                id={"annoCorso"}
                                classSelect={""}
                                onChange={(event) => {isDirty.current = true; onChangeAnnoCorso(parseInt(event.target.value));}}
                                baseOption={"Nessuna selezione"}
                                bindKey={"key"}
                                bindValue={"label"}
                                options={annoCorsoOptions}
                                disabled={!datiIscrizioneScolastica.ordineGrado}
                                value={datiIscrizioneScolastica.annoCorso ?? ""}
                                inputErrors={inputErrors}
                                required={true}
                            />
                        </div>
                        <div className="">
                            <fieldset className="rtds-input-field rtds-gap-2">
                                <legend className="rtds-input-field__label">
                                Studente iscritto all’anno scolastico {annoScolastico} con conferma di assegnazione. Indicare <strong className="rtds-content-02">NO</strong> se non ha avuto conferma di assegnazione oppure se è iscritto in una scuola fuori dalla Regione Toscana e nello specifico nelle seguenti regioni (Liguria, Emilia-Romagna, Lazio, Umbria e Marche):
                                    
                                    <abbr
                                        className="rtds-font-bold rtds-no-underline"
                                        title="obbligatorio"
                                    >
                                        *
                                    </abbr>
                                </legend>

                  
                                <Radio
                                    classDiv={'rtds-input-radio rtds-input--lg'}
                                    label={'Sì'}
                                    value="true"
                                    id={'true'}
                                    name="assegnazione"
                                    classInput={''}
                                    onChange={(event) => {isDirty.current = true; onChangeIsAssegnazioneConfermata(event.target.value === 'true');}}
                                    checked={datiIscrizioneScolastica.isAssegnato === true}
                                    required={datiIscrizioneScolastica.isAssegnato===null  || datiIscrizioneScolastica.isAssegnato===undefined}
                                ></Radio>

                                <Radio
                                    classDiv={'rtds-input-radio rtds-input--lg'}
                                    label={'No'}
                                    value="false"
                                    id={'false'}
                                    name="assegnazione" 
                                    classInput={''}
                                    onChange={(event) => {isDirty.current = true; onChangeIsAssegnazioneConfermata(event.target.value === 'true');}}
                                    checked={datiIscrizioneScolastica.isAssegnato === false}
                                    inputErrors={inputErrors}
                                    required={datiIscrizioneScolastica.isAssegnato===null || datiIscrizioneScolastica.isAssegnato===undefined}
                                ></Radio>
                            </fieldset>
                        </div>
                        <div className="rtds-field-row">
                            { datiIscrizioneScolastica.isAssegnato?
                                <>
                                    <Select
                                        classDiv={"rtds-mt-0 lg:rtds-mt-0"}
                                        label={"Comune della scuola"}
                                        id={"comune"}
                                        classSelect={""}
                                        onChange={(event) =>{isDirty.current = true; onChangeComune(parseInt(event.target.value));}}
                                        baseOption={"Nessuna selezione"}
                                        bindKey={"id"}
                                        bindValue={"denominazione"}
                                        options={comuni}
                                        disabled={!datiIscrizioneScolastica?.annoCorso}
                                        value={datiIscrizioneScolastica?.comune?.id ?? ''}
                                        inputErrors={inputErrors}
                                        required={datiIscrizioneScolastica.isAssegnato }
                                    />
                                    <Select
                                        classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                        label={"Scuola"}
                                        id={"scuola"}
                                        classSelect={""}
                                        onChange={(event) =>{isDirty.current = true; onChangePlesso(parseInt(event.target.value));}}
                                        baseOption={"Nessuna selezione"}
                                        bindKey={"id"}
                                        bindValue={"label"}
                                        options={plessi}
                                        loadingData={loadingData}
                                        disabled={!datiIscrizioneScolastica?.comune || loadingData}
                                        inputErrors={inputErrors}
                                        required={datiIscrizioneScolastica.isAssegnato}
                                        value={datiIscrizioneScolastica.plesso?.id ?? ""}
                                    />
                                    <Select
                                        classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                        label={"Indirizzo di studio"}
                                        id={"indirizzoDiStudio"}
                                        classSelect={""}
                                        onChange={(event) =>{isDirty.current = true; onChangeIndirizzoStudi(parseInt(event.target.value));}}
                                        baseOption={"Nessuna selezione"}
                                        bindKey={"id"}
                                        bindValue={"denominazione"}
                                        options={indirizziDiStudioOption}
                                        disabled={indirizziDiStudioOption?.length === 0}
                                        hidden={datiIscrizioneScolastica?.ordineGrado !== 'SUPERIORE'}
                                        inputErrors={inputErrors}
                                        required={datiIscrizioneScolastica.isAssegnato}
                                        value={datiIscrizioneScolastica?.indirizzoDiStudio?.id ?? ""}
                                        loadingData={loadingData}
                                    />
                                </> :
                                <Checkbox
                                    classDiv={'rtds-input-checkbox rtds-input--lg'}
                                    id={'confermaComunicazioneAssegnazione'}
                                    label={!isComunicazioneVisible ? '' : 'Mi impegno a comunicare successivamente la scuola a cui è iscritto lo studente beneficiario'}
                                    inputErrors={inputErrors}
                                    classInput={''}
                                    onChange={(event) =>{isDirty.current = true; onChangeConfermaAssegnazione(event.target.checked);}}
                                    checked={datiIscrizioneScolastica?.confermaComunicazioneAssegnazione || false}
                                    hidden={!isComunicazioneVisible}
                                    required={!datiIscrizioneScolastica.isAssegnato && isComunicazioneVisible}
                                />
                            }
                        </div>
                        <div hidden={!showWarning}>
                            <AlertMessage
                                title={"Attenzione!"}
                                message={"L’età dello studente è inferiore a 13 anni, verifica di avere selezionato la scuola corretta."}
                                classDiv={'rtds-text-warn-dark'}
                                classArticle={'rtds-bg-warn-light'}
                                iconName={'mini--exclamation-triangle'}
                            />
                        </div>
                    
                    <div className="rtds-border-gray-02 rtds-border-b rtds-border-t rtds-p-3 rtds-flex sm:justify-end justify-center">
                        <div className="rtds-form-actions">
                            <div
                                className="rtds-inline-flex rtds-gap-1"
                                role="group"
                                aria-label="Ruolo"
                            >
                                <button onClick={onPrevBtnClick}
                                    type="button"
                                    className="rtds-btn rtds-btn--secondary rtds-btn--icon-left rtds-group/button rtds-form-submit"
                                    disabled={inSave}
                                   
                                >
                                    <svg
                                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6  group-hover/button:-rtds-translate-x-1"
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                    >
                                        <use
                                            xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-uturn-left`}
                                        />
                                    </svg>{" "}
                                   Indietro
                                </button>
                                <button
                                    type="button"
                                    className="rtds-btn rtds-btn--primary rtds-form-submit rtds-btn--icon-right rtds-group/button"
                                    onClick={sendData}
                                    disabled={inSave}
                                >
                                    Salva<span className="lg:sx-diplay-none"> e vai avanti</span>
                                    {inSave ? (
                                        <>
                                            <svg
                                                className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 rtds-animate-spin md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6"
                                                aria-hidden="true"
                                                focusable="false"
                                                role="img"
                                            >
                                                <use  xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`} />
                                            </svg>
                                            <span className="rtds-sr-only">Caricamento...</span>
                                            </>
                                    ) : (
                                        <>
                                            <svg
                                                className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1"
                                                aria-hidden="true"
                                                focusable="false"
                                                role="img"
                                            >
                                                <use
                                                xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                                                />
                                            </svg>
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Step4IscrizioneScolastica;